import React, { useState, Fragment, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Switch from 'housecall-ui/dist/DesignSystem/Inputs/Switches/Switch';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import ConfirmationDialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/ConfirmationDialog';
import FormControlLabel from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormControlLabel';
import { toggleEnabledWithEntity } from '../Redux/Actions.js';
import { PODIUM } from '../AppsData.js';
import { getAppEnabled } from '../../../../Resources/Organization/Apps/AppsData.js';

const PodiumButton = () => {
  const appEnabled = useSelector(getAppEnabled(PODIUM));
  const [dialogOpen, setDialogOpen] = useState(false);
  const dispatch = useDispatch();
  const onToggleAppEnabled = () => dispatch(toggleEnabledWithEntity(PODIUM));

  const onSwitchChange = (event, checked) => {
    if (checked) {
      setDialogOpen(true);
    } else {
      onToggleAppEnabled();
    }
  };

  const onCloseDialog = useCallback(() => setDialogOpen(false), []);

  const onDialogConfirmationClick = useCallback(() => {
    setDialogOpen(false);
    onToggleAppEnabled();
    window.open('https://auth.podium.com/', '_blank');
  }, []);

  return (
    <>
      <FormControlLabel control={<Switch checked={appEnabled} onChange={onSwitchChange} />} label={appEnabled ? 'Active' : 'Disabled'} />
      <ConfirmationDialog
        open={dialogOpen}
        title="Connect to Podium"
        onClose={onCloseDialog}
        leftButton={<Button onClick={onCloseDialog}>Cancel</Button>}
        rightButton={(
          <Button color="primary" onClick={onDialogConfirmationClick}>
            Connect account
          </Button>
        )}
      >
        <Typography>
          You’re almost done. Sign up or login to your Podium account now to enable the integration.
        </Typography>
      </ConfirmationDialog>
    </>
  );
};

export default PodiumButton;
